<template>
  <div class="dropdown-selection w-80px h-32">
    <div class="dropdown-selection-head" @click="isShow = !isShow">
      <button class="btn h-32px w-100" style="position: relative">
        <span class="mr-5 w-40px">{{ numberOfItemsOnPage }}</span>
        <span v-if="isShow">
          <v-icon>arrow_drop_down</v-icon>
        </span>
        <span v-if="!isShow">
          <v-icon>arrow_drop_up</v-icon>
        </span>
      </button>
    </div>
    <div class="dropdown-selection-body block w-80px" v-if="isShow">
      <div
        class="pl-10px h-48px d-flex align-center selection-item-hover"
        v-for="item in items"
        :key="item.label"
        @click="changeItemPerPageStatus(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 10,
    },
  },
  data: () => ({
    isShow: false,
    items: [{ label: 10 }, { label: 20 }, { label: 50 }],
  }),
  computed: {
    numberOfItemsOnPage() {
      return this.value;
    },
  },
  methods: {
    changeItemPerPageStatus(item) {
      this.$emit('input', item.label);
      this.isShow = false;
      this.$emit('handleChangeEvent');
    },
  },
};
</script>

<style></style>
